import React, { Component } from "react";
import PropTypes from "prop-types";
import Header from "../components/Header.js";
import icon from "../images/icone-doc-assinado.png";
import RedirectAuthenticate from "../components/RedirectAuthenticate.js";

export class DocumentIsSigned extends Component {
  render() {
    return (
      <div className="container h-100">
        <Header logo={this.props.logo} />
        <div className="row text-center px-4" style={{ minHeight: "calc(100vh - 106px)" }}>
          <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-8 offset-xl-2 mt-5">
            <img src={icon} style={{ maxHeight: "105px" }} alt="" className="img-fluid mx-auto d-block mt-4" />
            <h1 className="card-title fw-bold text-white mt-3">DOCUMENTO JÁ ASSINADO</h1>
            {this.props.urlRedirect ? <RedirectAuthenticate urlRedirect={this.props.urlRedirect} /> : window.opener ? this.verifyPopUp() : ""}
          </div>
        </div>
      </div>
    );
  }
  verifyPopUp() {
    window.opener.postMessage([true, this.props.keyCallback], "*");
    window.close();
  }
}

export default DocumentIsSigned;
